import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import { SEOHead } from "@/hooks/useSEO";
import { useLanguage } from "@/hooks/useLanguage";
import {
  StructuredDataHead,
  LLMMetadataHead,
  organizationSchema,
  createWebPageSchema,
} from "@/hooks/useStructuredData";

const Impressum = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <SEOHead page="impressum" locale={language} />
      <StructuredDataHead schemas={[
        organizationSchema,
        createWebPageSchema(
          "Impressum | Chathero",
          "Impressum der Chathero GmbH.",
          "/impressum",
          [
            { name: "Home", url: "/" },
            { name: "Impressum", url: "/impressum" },
          ]
        ),
      ]} />
      <LLMMetadataHead
        title="Impressum | Chathero"
        description="Impressum der Chathero GmbH – Angaben gemäß § 5 TMG."
        keywords="Impressum, Imprint, Chathero, Legal"
        canonicalUrl="https://chathero.ai/impressum"
        aiCategory="Legal, Impressum"
        aiEntityType="Legal Page"
      />
      <Header />
      <main className="container mx-auto px-4 pt-40 pb-16 max-w-4xl">
        <article className="prose prose-lg max-w-none dark:prose-invert">
          <h1 className="text-4xl font-bold mb-8">
            {language === "de" ? "Impressum" : "Imprint"}
          </h1>

          <h2>{language === "de" ? "Ansprechpartner" : "Contact Person"}</h2>
          <p>{language === "de" ? "Geschäftsführung" : "Management"}: Martin Burst</p>

          <h3>{language === "de" ? "Hauptsitz" : "Head office"}</h3>
          <p>
            Chathero GmbH<br />
            Elsässerstr. 24<br />
            81667 München
          </p>

          <p>
            {language === "de" ? "Telefon" : "Phone"}: <a href="tel:+498944499973">+49 89 444 999 73</a><br />
            Fax: +49 89 444 999 72<br />
            E-Mail: <a href="mailto:info@chathero.ai">info@chathero.ai</a>
          </p>

          <p>
            {language === "de"
              ? "Handelsregisternummer: HRB 265259, Registergericht: Amtsgericht München, Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz: DE342603507 Verantwortlich gemäß § 55 RStV: Martin Burst"
              : "Commercial register number: HRB 265259, registration court: Munich local court, sales tax identification number according to §27a sales tax law: DE342603507 Responsible according to § 55 RStV: Martin Burst"}
          </p>

          <h2>{language === "de" ? "Urheberrecht" : "Copyright"}</h2>
          <p>
            {language === "de"
              ? "Der Text ist urheberrechtlich geschützt. Die Verwendung der Texte und Bilder – auch auszugsweise – ohne schriftliche Genehmigung der Chathero GmbH ist strafbar. Dies gilt insbesondere für die Vervielfältigung, Verwendung in Schulungsunterlagen oder elektronischen Systemen."
              : "The text is protected by copyright. The use of the texts and pictures – even in extracts – without written permission of Chathero GmbH is punishable by law. This applies in particular to copying, use in training documents or electronic systems."}
          </p>
          <p>
            {language === "de"
              ? "Alle Rechte vorbehalten. Alle Texte, Bilder, Grafiken unterliegen dem Urheberrecht und anderen Gesetzen zum Schutz geistigen Eigentums. Sie dürfen nicht für kommerzielle Zwecke oder zur Weitergabe kopiert, verändert und auf anderen Websites verwendet werden."
              : "All rights reserved. All texts, pictures, graphics, are subject to copyright and other laws for the protection of intellectual property. They may not be copied for commercial purposes or for distribution, nor may they be changed and used on other websites."}
          </p>

          <h2>{language === "de" ? "Gewährleistung" : "Warranty"}</h2>
          <p>
            {language === "de"
              ? "Die auf der Website veröffentlichten Informationen werden von der Chathero GmbH ohne jede Zusicherung oder Garantie jedweder Art, ob ausdrücklich oder stillschweigend, zur Verfügung gestellt."
              : "The information published on the website is provided by Chathero GmbH without any assurance or guarantee of any kind, whether explicit or implicit."}
          </p>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default Impressum;
